//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        result: {
            type: Object
        },
        route: {
            type: String,
            default: 'next'
        },
        label: {
            type: String,
            default: function () {
                return this.$lang.get('partials.button.continue');
            }
        },
        type: {
            type: String,
            default: 'success'
        },
        width: {
            type: Number,
            default: 240
        },
        x: {
            type: Number,
            default: 600
        },
        y: {
            type: Number,
            default: 760
        },
        showDelay: {
            type: Number,
            default: 0
        },
        currentRoute: {
            type: String,
            default: ''
        },
        finishDay: {
            type: Boolean,
            default: false
        },
        finishWeek: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            loading: false
        };
    },

    methods: {
        async next () {
            try {
                this.loading = true;

                if (this.result !== undefined) {
                    await this.storeGameResults();
                }

                if (this.currentRoute !== '') {
                    await this.storeCurrentRoute();
                }

                if (this.finishDay) {
                    await this.storeFinishDay();
                }

                if (this.finishWeek) {
                    await this.storeFinishWeek();
                }

                if (this.finishWeek && this.$store.getters.hasUserFinishedGame) {
                    this.$router.push({ name: 'certificate' });
                } else {
                    this.$router.push({ name: this.route });
                }

                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        storeGameResults () {
            return new Promise((resolve, reject) => {
                axios.post('game/results', {
                    week: this.$route.meta.week,
                    day: this.$route.meta.day,
                    game: this.$route.meta.game,
                    value: this.result.stars,
                    skipped: this.result.skipped,
                    help: this.result.help,
                    wrong: this.result.wrong,
                    correct: this.result.correct,
                    selfassessment: this.result.selfassessment
                }).then(response => {
                    this.$store.commit('storeGameData', response.data.data);
                    resolve(response);
                }).catch((error) => reject(error));
            });
        },
        storeCurrentRoute () {
            return new Promise((resolve, reject) => {
                axios.post('users/route', {
                    current_route: this.currentRoute,
                    week: this.$route.meta.week,
                    reset_week_route: this.finishWeek
                }).then(() => {
                    this.$store.commit('storeCurrentRoute', this.currentRoute);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        storeFinishDay () {
            return new Promise((resolve, reject) => {
                axios.post('game/finish-day', {
                    day: this.$route.meta.day,
                    week: this.$route.meta.week
                }).then(response => {
                    this.$store.commit('storeGameData', response.data.data);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        storeFinishWeek () {
            return new Promise((resolve, reject) => {
                axios.post('game/finish-week', {
                    week: this.$route.meta.week
                }).then(response => {
                    this.$store.commit('storeGameData', response.data.data);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        }
    }
};
